import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Pricing.css";
import { useApi } from "../../hooks/ApiProvider/ApiProvider";
import { formatNumber, createSafeHtml } from "../../utils/UtilsFunc";

const Pricing: React.FC = () => {
  const { getProducts } = useApi();
  const navigate = useNavigate();
  const loaction = useLocation();

  const [products, setProducts] = useState<any>({});

  const handlePurchase = (planId: string) => {
    if (!localStorage.getItem("membership_access_token")) {
      alert(`회원만 멤버십 결제 가능합니다.`);
      navigate(`/login`);
      window.location.reload();
      return;
    }

    navigate(`/order?planId=${planId}`);
    window.location.reload();
  };

  useEffect(() => {
    const fetchProducts = async () => {
      const products = await getProducts();
      setProducts(products);
    };
    fetchProducts();
  }, []);

  const PricingDiv = () => {
    return (
      <>
        <div className={`contents_wrap wrap_1`}>
          <div className={`sec`}>
            <div className={`flex items-center justify-center `}>
              <div className={`sub_tit rounded-3xl`}>요금제 소개</div>
            </div>
            <div className={`text-center main_tit_box`}>
              <h3 className={`h1 tit`}>런칭 할인가로 만나보세요</h3>
              <p className={`txt h4_sb`}>소중한 사람들에게 따뜻한 이야기를 선물하세요</p>
            </div>
            <ul className={`flex flex-wrap items-stretch price_list_ul justify-center`}>
              <li className={`card_layout`}>
                <div className={`price_box`}>
                  <h3 className={`price_name h2`}>{products["digital"]?.name}</h3>
                  <p className={`price_old body2`}>
                    <del>{formatNumber(products["digital"]?.originalPrice) ?? "139,000"}원</del>
                  </p>
                  <p className={`price_new h2`}>
                    {formatNumber(products["digital"]?.price) ?? "99,000"}원
                  </p>
                </div>
                <button
                  onClick={() => handlePurchase(products["digital"]?.id)}
                  className={`btn btn-outline-primary`}
                >
                  구매하기
                </button>
                <ul className={`proc_ul`}>
                  {products["digital"]?.features.map((item: any, index: number) => (
                    <li className={`body2`} key={index}>
                      <p dangerouslySetInnerHTML={createSafeHtml(item)}></p>
                    </li>
                  ))}
                </ul>
              </li>
              <li className={`card_layout`}>
                <div className={`price_box`}>
                  <h3 className={`price_name h2 flex items-center`}>
                    {products["premium"]?.name}
                    <strong className={`rounded-3xl caption`}>선물로 추천</strong>
                  </h3>
                  <p className={`price_old body2`}>
                    <del>{formatNumber(products["premium"]?.originalPrice) ?? "389,000"}원</del>
                  </p>
                  <p className={`price_new h2`}>
                    {formatNumber(products["premium"]?.price) ?? "249,000"}원
                  </p>
                </div>
                <button
                  onClick={() => handlePurchase(products["premium"]?.id)}
                  className={`btn btn-primary`}
                >
                  구매하기
                </button>
                {/* <button className={`btn btn-primary`}>구매하기</button> */}
                <ul className={`proc_ul`}>
                  {products["premium"]?.features.map((item: any, index: number) => (
                    <li className={`body2`} key={index}>
                      <p dangerouslySetInnerHTML={createSafeHtml(item)}></p>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
            <div className={`warning_message`}>
              <p>
                본 상품은 안드로이드 기기에서만 이용할 수 있습니다.
                <br />
                iOS(아이폰) 기기에서는 이용이 불가하니 구매 전 꼭 확인해주세요.
              </p>
            </div>
          </div>
        </div>
        <div className={`contents_wrap wrap_2`}>
          <div className={`sec`}>
            <div className={`flex items-center justify-center `}>
              <div className={`sub_tit rounded-3xl`}>제작 및 배송 일정</div>
            </div>
            <div className={`text-center main_tit_box`}>
              <h3 className={`h1 tit`}>이야기가 책으로 바뀌는 데 걸리는 시간</h3>
              <p className={`txt h4_sb`}>
                평균적으로 디지털 요금제는 3주, 프리미엄 요금제는 5주 정도 걸려요.
              </p>
            </div>
            <div className={`tables`}>
              <div className={`rows relative flex items-center text-center`}>
                <div className={`w-[30%] body1_sb`}>인터뷰 진행</div>
                <div className={`w-[30%] body1`}>평균 3주</div>
                <div className={`w-[40%] body1`}>기간은 사용자의 진행 속도에 따라 달라짐</div>
                {/*<div className={`cuts`}>* 디지털 요금제는 여기까지</div>*/}
              </div>
              <div className={`rows relative flex items-center text-center`}>
                <div className={`w-[30%] body1_sb`}>전자책 제작</div>
                <div className={`w-[30%] body1`}>평균 30분</div>
                <div className={`w-[40%] body1`}>인터뷰 완료 후 전자책 제작 신청</div>
                <div className={`cuts body2`}>* 디지털 요금제는 여기까지</div>
              </div>
              <div className={`rows relative flex items-center text-center`}>
                <div className={`w-[30%] body1_sb`}>실물책 편집 및 인쇄</div>
                <div className={`w-[30%] body1`}>7~10일</div>
                <div className={`w-[40%] body1`}>전자책 내용 확인 후 실물책 배송 신청</div>
                {/*<div className={`cuts`}>* 디지털 요금제는 여기까지</div>*/}
              </div>
              <div className={`rows relative flex items-center text-center`}>
                <div className={`w-[30%] body1_sb`}>배송</div>
                <div className={`w-[30%] body1`}>2~3일</div>
                <div className={`w-[40%] body1`}>도서 산간 지역 5~7일 소요</div>
                {/*<div className={`cuts`}>* 디지털 요금제는 여기까지</div>*/}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  if (loaction?.pathname === "/") {
    return (
      <>
        <section id="pricing" className="pricing-section">
          {PricingDiv()}
        </section>
      </>
    );
  }
  if (loaction?.pathname !== "/") {
    return (
      <div className={`content_wrap pricing`}>
        <section id="pricing" className="pricing-section">
          {PricingDiv()}
        </section>
      </div>
    );
  }

  return null;
};

export default Pricing;
